import React, {Component} from 'react'
import PropTypes from "prop-types";
import '../../components_style/rtl_css/FormElementContainer.css'
import '../../components_style/FormElementContainer.css'
import SvGraphics from "../../assets/SvGraphics";

class FormElementContainerExpanded extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded:false
        };
    }


    onClickArrow= ()=> {
        this.setState({isExpanded: !this.state.isExpanded})
    }

    render() {
        let {isExpanded}=this.state
        let {title,Component,rest,isSub} = this.props
        return (
            <div  className={'patientForm-box-container'}>
                { {title}!=='' ?
                    <div className={isExpanded?'patientsFormBoxes-title-text':'patientsFormBoxes-title-board'} style={{display:'flex'}}>
                        <label className={'patientsFormBoxes-title-text-label'}>   {title}</label>
                        <SvGraphics className={!isExpanded?"patient-onboard-arrow":"patient-onboard-arrow-rotate"} width={'15px'} height={'15px'} svgname={'arrow-down'} onClick={()=>this.onClickArrow()}/>
                    </div>
                    : ""}
                {isExpanded && <Component {...rest} />}
            </div>
        )
    }
}

FormElementContainerExpanded.propTypes = {
    title: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default FormElementContainerExpanded;
